import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import SetCommissionPop from "../../../components/Modals/SetcommissionPop";
import dataHandler from "../../../hooks/dataHandler";
import TableActions from "../../../components/Common/TableActions";
import {
  DELETE_COMMISSION,
  FINANCEOVERVIEWAPI,
  HANDLETRANCATIONAPI,
  SET_COMMISSION,
} from "../../../services/ApiCalls";
import { activeInactiveOptions } from "../../../utilities/const";
import moment from "moment";
import {
  catchAsync,
  checkResponse,
  exportCsvHandler,
} from "../../../utilities/utilities";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import CountryFilter from "../../../components/Common/CountryFilter";
import HotelAdminFilter from "../../../components/Common/HotelAdminFilter";
import FinanceData from "./Components/StatData/index";
import RevenuePerformance from "./Components/BookingPerformance";
import RevenueChart from "./Components/BookingChart";
import { useTranslation } from "react-i18next";

const ManageEarning = () => {
  const { t } = useTranslation();
  const [exportLoader, setExportLoader] = useState();
  const [dashboardData, setDashboardData] = useState(null);
  const [financeStatus, setFinanceStatus] = useState("");
  const [financeSearch, setFinanceSearch] = useState("");
  const [state, setState] = useState({ tab: "tab1" });
  const [commissionModel, setCommissionModel] = useState({
    show: false,
    dumpId: "",
    commission: "",
  });
  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader,
    refetch,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: HANDLETRANCATIONAPI,
  });

  const getOverviewData = async () => {
    let res = await FINANCEOVERVIEWAPI();
    checkResponse({ res, setData: setDashboardData, setLoader: () => { } });
  };

  useEffect(() => {
    getOverviewData();
  }, []);

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => <>{key < 9 ? `${key + 1}` : key + 1}</>,
    },
    {
      head: "TransactionId",
      accessor: "transaction",
      component: (item) => (
        <span className="d-block text-truncate">
          {item?.transactionId ? item?.transactionId : "--"}
        </span>
      ),
    },
    {
      head: "BookingId",
      accessor: "transaction",
      component: (item) => (
        <span className="bookingid d-block text-truncate">
          {" "}
          {item?.bookingDetail?.bookingId}
        </span>
      ),
    },
    {
      head: "Hotel Name",
      accessor: "hotelName",
      component: (item) => (
        <span className="d-block text-truncate">
          {" "}
          {item?.hotelDetail?.hotelName}
        </span>
      ),
    },
    {
      head: "User Name",
      accessor: "first_name",
      component: (item) => (
        <>
          {" "}
          {item?.customerDetail?.first_name}
          {item?.customerDetail?.last_name}
        </>
      ),
    },

    {
      head: "Time",
      accessor: "createdAt",
      component: (item) => (
        <span className="d-block text-truncate">
          {moment(item?.createdAt).format("MM-DD-YYYY , HH:mm")}
        </span>
      ),
    },
    {
      head: "Payment Type",
      accessor: "paymentMethod",
      component: (item) => (
        <span className="text-capitalize">{item?.paymentMethod || "-"}</span>
      ),
    },

    {
      head: "Amount",
      accessor: "amount",
      component: (item) => (
        <>
          {item?.currencySymbol}
          {item?.amount}
        </>
      ),
    },

    {
      head: "Status",
      accessor: "status",
      component: (item) => (
        <p className={`status m-0 status_${item?.status}`}>
          {item?.status.charAt(0).toUpperCase() + item?.status.slice(1)}
        </p>
      ),
    },

    {
      head: "Action",
      accessor: "Action",
      component: (item) => (
        <TableActions viewLink={`/manage-earning/${item._id}`} />
      ),
    },
  ];

  const commissionSetHandler = catchAsync(async (data) => {
    const res = await SET_COMMISSION({ ...data, _id: commissionModel.dumpId });
    const success = checkResponse({ res, showSuccess: true });
    if (success) {
      setCommissionModel({ show: false, commission: "", dumpId: "" });
      refetch();
    }
  });

  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        // setConfirmation={() => deleteModel(defaultDeleteModelState)}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() =>
            DELETE_COMMISSION({
              _id: deleteModel.dumpId,
            })
          )
        }
      />
      <SetCommissionPop
        show={commissionModel.show}
        setCommissionModel={setCommissionModel}
        hideHandle={() =>
          setCommissionModel({ show: false, dumpId: "", commission: "" })
        }
        commission={commissionModel.commission}
        submitHandler={commissionSetHandler}
      />
      <section className="manageCommissions  position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("finance.title")}
                </h4>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    <li className="">

                      {state.tab == "tab2" && (
                        <Button
                          className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                          style={{ height: 40, minWidth: 100, fontSize: 12 }}
                          type="button"
                          onClick={() =>
                            exportCsvHandler("financeCsv", setExportLoader, {
                              "status": financeStatus,
                              // "startTime": "2024-01-01T00:00:00.000Z",
                              // "endTime": "2024-12-31T23:59:59.999Z",
                              "search": financeSearch
                            })
                          }
                        >
                          {exportLoader ? <ButtonLoader /> : "Export CSV"}
                        </Button>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="tab-frame">
                <div className="clearfix">
                  <input
                    type="radio"
                    name="tab"
                    id="tab1"
                    checked={state.tab == "tab1"}
                    onClick={() => setState({ tab: "tab1" })}
                  />
                  <label for="tab1">
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M16.808 19q-.344 0-.576-.232T16 18.192V15q0-.343.232-.575t.576-.233h1.384q.344 0 .576.232T19 15v3.192q0 .344-.232.576t-.576.232zm-5.5 0q-.344 0-.576-.232t-.232-.576V5.808q0-.343.232-.576T11.308 5h1.384q.344 0 .576.232t.232.576v12.384q0 .344-.232.576t-.576.232zm-5.5 0q-.344 0-.576-.232T5 18.192v-7.567q0-.358.232-.587t.576-.23h1.384q.343 0 .576.232t.232.576v7.567q0 .358-.232.587t-.576.23z"
                        />
                      </svg>
                    </span>
                    {t("finance.overview")}
                  </label>
                  {/* 
                  <input
                    type="radio"
                    name="tab"
                    id="tab2"
                    checked={state.tab == "tab2"}
                    onClick={() => setState({ tab: "tab2" })}
                  />
                  <label for="tab2">
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        >
                          <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                          <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2M9 7h1m-1 6h6m-2 4h2" />
                        </g>
                      </svg>
                    </span>
                    Payout & Invoice (Settlement/Documents)
                  </label> */}
                </div>

                {state.tab == "tab1" && (
                  <div className="Finance_main text-center mt-4">
                    <Col lg="12" className="">
                      <FinanceData summaryCards={dashboardData?.summaryCards} />
                    </Col>

                    <Row>
                      <Col lg="6" md="6" sm="12" className="my-2">
                        <RevenuePerformance data={dashboardData} />
                      </Col>
                      <Col lg="6" md="6" sm="12" className="my-2">
                        <RevenueChart dashboardData={dashboardData} />
                      </Col>
                    </Row>
                  </div>
                )}

                {state.tab == "tab2" && (
                  <div className="tableFilter text-center mt-4">
                    <Col lg="12" className="my-2">
                      <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                        <div className="left">
                          <HotelAdminFilter
                            body={body}
                            searchHandler={searchHandler}
                            setBody={setBody}
                            statusFilterOptionArr={activeInactiveOptions}
                            type="finance"
                            setFinanceStatus={setFinanceStatus}
                            setFinanceSearch={setFinanceSearch}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <TableLayout
                        column={column}
                        data={data}
                        loader={loader}
                      />
                      <CustomPagination
                        total={total}
                        body={body}
                        setBody={setBody}
                        pageChangeHandler={paginationHandler}
                      />
                    </Col>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageEarning;
